import { render } from "./UserProgress.vue?vue&type=template&id=373fcd1c&scoped=true&ts=true"
import script from "./UserProgress.vue?vue&type=script&lang=ts"
export * from "./UserProgress.vue?vue&type=script&lang=ts"

import "./UserProgress.vue?vue&type=style&index=0&id=373fcd1c&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-373fcd1c"]])

export default __exports__